import FaqEdit from './FaqEdit';

export default FaqEdit;
